import Quaternion from './math/Quaternion';
import Vector3 from './math/Vector3';
import Euler from './math/Euler';

const initedClassName = 'swipevideo-isinit';

function getVisiblePlayer(list, disc) {
  const result = [];

  list.forEach((refObject) => {
    if (!refObject.$info || !refObject.$info[disc]) return;
    const bounding = refObject.elem.getBoundingClientRect();
    const wh = window.innerHeight;

    if (bounding.top < wh && bounding.top > -bounding.height) result.push(refObject);
  });

  return result;
}

function degToRad(deg) {
  return (deg * Math.PI) / 180;
}

export default {
  initedClassName,
  formatValue(elem, val) {
    const tmpVal = Object.assign(
      ['cid', 'src', 'ref', 'filter', 'iconcolor']
        .reduce((prev, key) => (Object.assign({}, prev, { [key]: elem.getAttribute(`data-${key}`) || elem.getAttribute(`data-sv-${key}`) || elem.getAttribute(`sv-${key}`) })), {}),
      ['loop', 'muted', 'controls', 'head', 'lazyload', 'autoplay', 'title', 'swipingwidth', 'poster', 'iconhover', 'allowfullscreen', 'autoswipe', 'jyroswipe', 'stereoview']
        .reduce((prev, key) => (Object.assign({}, prev, { [key]: JSON.parse(elem.getAttribute(`data-${key}`) || elem.getAttribute(`data-sv-${key}`) || elem.getAttribute(`sv-${key}`)) })), {}),
      val,
    );

    const param = {};
    Object.keys(tmpVal).forEach((key) => {
      const value = tmpVal[key];
      if (value === null) return;

      switch (key) {
        case 'src': {
          const fileNameLike = value.match(/\/([^/]+?\.[^/]+?)($|\?)/);
          if (fileNameLike === null) param.src = /\/$/.test(value) ? value.slice(0, -1) : value;
          else param.src = value.slice(0, fileNameLike.index);
          param.iframeSrc = value;
          break;
        }
        case 'cid':
          param.contentId = value;
          break;
        case 'head':
          param.headIndex = value;
          break;
        case 'title':
          param.showingTitle = value;
          break;
        case 'swipingwidth':
          param.swipingWidth = value;
          break;
        default:
          param[key] = value;
          break;
      }
    });

    return param;
  },
  genInfo(param, queryString, json) {
    let headIndex = 0;
    if (param.headIndex) {
      headIndex = typeof param.headIndex === 'number'
        ? param.headIndex
        : json.srcset.findIndex(data => (data[0] === param.headIndex));
    }

    return Object.assign(
      {
        queryString,
        cdnQueryString: param.$cdnAuth ? `?${param.$cdnAuth}` : queryString,
        contentId: '',
        headIndex,
        loop: false,
        muted: false,
        controls: true,
        duration: json.srcset[
          json.audio === -1 ? headIndex : json.audio][1],
        autoplay: false,
        showingTitle: true,
        swipingWidth: 20,
        filter: '',
        poster: 0,
        iconcolor: '#E60014',
        iconhover: false,
        allowfullscreen: true,
        autoswipe: true,
        jyroswipe: false,
        stereoview: false,
      },
      json,
      param,
    );
  },
  initAutoSwipe(refList) {
    let prevScrollY = 0;

    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      if (Math.abs(scrollY - prevScrollY) < 60) return;

      const value = scrollY - prevScrollY < 0 ? -1 : 1;

      getVisiblePlayer(refList, 'autoswipe').forEach((refObject) => {
        refObject.addSrcIndex(value);
      });

      prevScrollY = scrollY;
    }, false);
  },
  initJyroSwipe(refList) {
    let deviceOrientation = {};
    let screenOrientation = 0;
    const onDeviceOrientationChangeEvent = (e) => {
      deviceOrientation = e;
    };
    const onScreenOrientationChangeEvent = () => {
      screenOrientation = window.orientation || 0;
    };
    onScreenOrientationChangeEvent();
    window.addEventListener('orientationchange', onScreenOrientationChangeEvent, false);
    window.addEventListener('deviceorientation', onDeviceOrientationChangeEvent, false);

    const zee = new Vector3(0, 0, 1);
    const euler = new Euler();
    const quaternion = new Quaternion();
    const q0 = new Quaternion();
    const q1 = new Quaternion(-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5)); // - PI/2 around the x-axis

    const setObjectQuaternion = (alpha, beta, gamma, orient) => {
      euler.set(beta, alpha, -gamma, 'YXZ'); // 'ZXY' for the device, but 'YXZ' for us
      quaternion.setFromEuler(euler); // orient the device
      quaternion.multiply(q1); // camera looks out the back of the device, not the top
      quaternion.multiply(q0.setFromAxisAngle(zee, -orient)); // adjust for screen orientation
      euler.setFromQuaternion(quaternion);
      getVisiblePlayer(refList, 'jyroswipe').forEach((refObject) => {
        refObject.$swipeByEuler(euler);
      });
    };

    const update = () => {
      requestAnimationFrame(update);
      if (typeof deviceOrientation.alpha !== 'number') return;

      const alpha = deviceOrientation.alpha ? degToRad(deviceOrientation.alpha) : 0; // Z
      const beta = deviceOrientation.beta ? degToRad(deviceOrientation.beta) : 0; // X'
      const gamma = deviceOrientation.gamma ? degToRad(deviceOrientation.gamma) : 0; // Y''
      const orient = screenOrientation ? degToRad(screenOrientation) : 0; // O
      setObjectQuaternion(alpha, beta, gamma, orient);
    };
    update();
  },
};



// WEBPACK FOOTER //
// ./src/utils.js